import { useState, useEffect } from "react";
import TopMenu from "../../layout/TopMenu/TopMenu";
import SideMenu from "../../layout/SideMenu/SideMenu";
import { Outlet } from "react-router-dom";

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isLargeScreen = window.matchMedia("(min-width: 1024px)").matches;
      if (isLargeScreen && sidebarOpen) {
        setSidebarOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [sidebarOpen]);

  return (
    <div className="dark:bg-boxdark-2 dark:text-bodydark">
      <div className="flex h-screen overflow-hidden">
        <SideMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
          <TopMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

          <main className={`${sidebarOpen ? "overflow-hidden" : "overflow-auto"}`}>
            <div className="mx-auto max-w-full h-[calc(100vh-100px)] md:p-5 p-3">
              <Outlet />
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
